import { Injectable } from '@angular/core';
import { HttpRequestDecorator } from '../core/triggerbee/http.request.decorator';
import { TriggerbeeApi } from '../core/triggerbee/triggerbee-api.enum';
import { Observable } from 'rxjs';
import { Audience, LiveData, WeatherAppsKeyValuePair } from './components/audience.model';
import { SessionConditionGroup } from './components/session-condition-group.model';

@Injectable({
  providedIn: 'root',
})
export class AudienceService {
  constructor(private http: HttpRequestDecorator) {}

  private getAudiencesResource(subResource?: string): string {
    return this.http.getBaseUrl(TriggerbeeApi.Gateway) + `/audiences` + (subResource || '');
  }

  public getAllWeatherApps(): Observable<Array<WeatherAppsKeyValuePair>> {
    const url = this.http.getBaseUrl(TriggerbeeApi.Gateway) + `/weather/apps`;
    return this.http.get(url);
  }

  public getAllAudiences(): Observable<Array<Audience>> {
    return this.http.get(this.getAudiencesResource());
  }

  public updateAudience(audience: Audience): Observable<Audience> {
    const url = this.getAudiencesResource(`/${audience.id}`);
    return this.http.put(url, audience);
  }

  public createAudience(audience: Audience): Observable<Audience> {
    const url = this.getAudiencesResource();
    return this.http.post(url, audience);
  }

  public deleteAudience(audienceId: string): Observable<any> {
    return this.http.delete(this.getAudiencesResource(`/${audienceId}`));
  }

  public getAudienceById(audienceId: string): Observable<Audience> {
    return this.http.get(this.getAudiencesResource(`/${audienceId}`));
  }

  public getLiveData(timeOffset: number): Observable<Array<LiveData>> {
    const path = '/visitor-sessions/actions';
    const data = {
      timeOffset,
      take: 10,
    };
    return this.http.get(this.http.getBaseUrl(TriggerbeeApi.Gateway) + path, data);
  }
}
